<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-show="false" :name="$options.name" v-bind="$attrs" ref="yt"> </yi_curd_table>
    <div class="container">
      <!-- 左侧按钮插槽 -->

      <el-button size="mini" @click="onAddData" type="primary">
        {{ $t('xinzeng') }}
      </el-button>

      <!-- 右侧按钮插槽 -->

      <!--      <div style="float: right">-->
      <!--        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"-->
      <!--            @click="yt.showColumnsDialog()"></el-button>-->
      <!--      </div>-->
      <div style="margin-top: 12px">
        <el-table class="tables" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', 'font-size': '14px', height: '48px', padding: '0px' }" :show-overflow-tooltip="true" size="mini" border stripe max-height="600">
          <el-table-column prop="time" :label="$t('tixingshijianfanwei')" width="280" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="userIds" :label="$t('yonghu')" width="220" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ getNameById(scope.row.userIds) }}
            </template>
          </el-table-column>
          <el-table-column prop="interval" :label="$t('jiange(fenzhong)')" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column :label="$t('caozuo')" fixed="right" :show-overflow-tooltip="true" width="150">
            <template slot-scope="scope">
              <span style="color:#1894ec;font-size: 14px;font-family: Microsoft YaHei UI;" @click="edit(scope.row)">{{ $t('bianji') }}</span>
              <span style="color:#F56C6C;font-size: 14px;font-family: Microsoft YaHei UI;margin-left: 8px" @click="deleteRow(scope.$index, scope.row)">{{ $t('shanchu') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <!-- 新增/编辑弹框 -->
      <el-dialog :show-close="true" :title="$t('peizhixianshilie')" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" append-to-body="append-to-body">
        <!-- 添加 -->
        <!--<div class="dialog-scroller"></div>-->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" :model="currentItem" :rules="rules">
          <el-form-item :label="$t('shijianfanwei')" required prop="beginTimeString">
            <el-time-select
              :placeholder="$t('qishishijian')"
              v-model="currentItem.beginTimeString"
              value-format="HH"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '24:00'
              }"
            >
            </el-time-select>
            <el-time-select
              :placeholder="$t('jieshushijian')"
              v-model="currentItem.endTimeString"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '24:00',
                minTime: currentItem.isCross === 0 ? currentItem.beginTimeString : false
              }"
            >
            </el-time-select>
            <!--                <yi_time_input type="datetime" :start.sync="currentItem.beginTime"-->
            <!--                    :end.sync="currentItem.endTime">-->
            <!--                </yi_time_input>-->
            <el-checkbox v-model="currentItem.isCross" :true-label="1" :false-label="0">{{ $t('kuatian') }}</el-checkbox>
          </el-form-item>
          <div style="display:flex;flex-wrap: nowrap;" v-if="codeName.code === 'equipment_idle' || codeName.code === 'equipment_fault' || codeName.code === 'equipment_fault_group' || codeName.code ==='standard_cycle_compare'">
            <el-form-item :label="$t('jiange(fenzhong)')" required prop="interval">
              <el-input type="number" v-model.number="currentItem.interval" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifouzhitixingyici')">
              <el-switch v-model="currentItem.isSingleTime" :active-value="1" :inactive-value="0"> </el-switch>
            </el-form-item>
          </div>
          <el-form-item :label="$t('yonghu')" required prop="userIds">
            <yi_cross_select multiple :component="'web_system_user_list'" :ids.sync="currentItem.userIds" @getItems="getItems"> </yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="dialogVisible = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" type="primary" @click="saveFrame()">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_early_warning_management_alert_settings_time_list',
  props: ['changeTypeId'],
  data() {
    return {
      format: 'HH',
      codeName: null,
      tableData: [],
      userList: [],
      currentItem: {
        beginTime: '',
        endTime: '',
        interval: '',
        isSingleTime: 0,
        userIds: []
      },
      dialogVisible: false,
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      rules: {
        beginTimeString: [{ required: true, message: '必填' }],
        interval: [{ required: true, message: '必填' }],
        userIds: [{ required: true, message: '必填' }]
      }
    };
  },
  watch: {
    changeTypeId: {
      handler(n, o) {
        if (n) {
          this.codeName = n;
        }
        console.log('changeTypeIdvalue', n);
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    console.log('changeTypeId', this.changeTypeId);
  },
  methods: {
    getNameById(idList) {
      if (Array.isArray(idList) && idList.length > 0) {
        return this.userList
          .filter(item => {
            return idList.includes(item.id);
          })
          .map(item => {
            return item.nickname;
          })
          .join(',');
      }
      return '';
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },
    onAddData() {
      this.currentItem = {};
      this.$set(this.currentItem, 'isCross', 0);
      this.dialogVisible = true;
    },
    saveFrame() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const index = this.tableData.findIndex(item => item.id === this.currentItem.id);
          // 对时间格式化
          if (!this.currentItem.beginTimeString) {
            this.$message.error(this.$t('exp_valid_startTime_null'));
            return;
          }
          if (!this.currentItem.endTimeString) {
            this.$message.error(this.$t('exp_valid_endTime_null'));
            return;
          }
          if (this.currentItem.beginTimeString && this.currentItem.endTimeString) {
            this.$set(this.currentItem, 'time', this.currentItem.beginTimeString + '-' + this.currentItem.endTimeString);
          }
          if (index >= 0) {
            // 修改数据
            this.tableData.splice(index, 1, this.currentItem);
          } else {
            // 新增数据
            this.tableData.push(Object.assign({}, this.currentItem, { id: this.tableData.length + 1 }));
          }
          console.log('this.tableData', this.tableData);
          this.dialogVisible = false;
        }
      });
      // console.log('currentItem11',this.currentItem)
      // this.$refs.form.validate((valid) => {
      //     if (valid) {
      //         alert('submit!');
      //     } else {
      //         console.log('error submit!!');
      //         return false;
      //     }
      // });

      // this.$refs.form.validate((valid)=>{
      //         if (valid) {
      //
      //         }
      // })
    },
    edit(row) {
      this.currentItem = { ...row };
      this.dialogVisible = true;
    },
    // 删除行
    deleteRow(index, row) {
      this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          this.tableData.splice(index, 1);
        })
        .catch(() => {});
    },
    getItems(checks) {
      if (Array.isArray(checks) && checks.length > 0) {
        checks.forEach(item => {
          const result = this.userList.find(value => {
            return value.id == item.id;
          });
          if (!result) {
            this.userList.push(item);
          }
        });
      }
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    }
  }
};
</script>
